import { isWeb } from "@memorang/helpers/platform";
import { router } from "expo-router";
import { useState } from "react";

export function useLegacyReportDownload() {
	const [downloadingId, setDownloadingId] = useState<number | null>(null);

	const handleDownload = (numericId: number) => {
		if (isWeb) {
			setDownloadingId(numericId);
		} else {
			router.push(`/session/${numericId}/report/`);
		}
	};

	return {
		downloadingId: downloadingId ?? undefined,
		handleDownload,
		clearDownload: () => setDownloadingId(null),
	};
}
